
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from '@/components/ui/card';
import { Info } from 'lucide-react';

interface PrivateAccessMessageProps {
  communityName: string;
  adminContact: string | null;
}

export function PrivateAccessMessage({ communityName, adminContact }: PrivateAccessMessageProps) {
  return (
    <div className="min-h-[400px] flex items-center justify-center p-8">
      <Card className="max-w-md w-full">
        <CardHeader className="text-center">
          <div className="mx-auto mb-4 w-12 h-12 rounded-full bg-primary/10 flex items-center justify-center">
            <Info className="h-6 w-6 text-primary" />
          </div>
          <CardTitle className="text-2xl font-bold">Private Community</CardTitle>
          <CardDescription className="mt-2">
            {communityName} is a private community that requires an invitation to join.
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-4">
          {adminContact && (
            <div className="text-center">
              <p className="text-muted-foreground mb-1">Contact administrator:</p>
              <a 
                href={`mailto:${adminContact}`} 
                className="text-primary hover:underline"
              >
                {adminContact}
              </a>
            </div>
          )}
        </CardContent>
      </Card>
    </div>
  );
}
